export enum RouterAuthEnum {
  Login = 'login',
  Callback = 'auth-callback',
  Forbidden = 'forbidden',
  LoggedOut = 'loggedout',
}
